import { render, staticRenderFns } from "./PaymentSuccessful.vue?vue&type=template&id=40870467&scoped=true&"
import script from "./PaymentSuccessful.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSuccessful.vue?vue&type=style&index=0&id=40870467&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40870467",
  null
  
)

export default component.exports